mutation deleteInviteLeadToLandingpage($input: DeleteLeadsToLandingpageInput!) {
    deleteInviteLeadToLandingpage: deleteInviteLeadToLandingpage(input: $input)
}
